import { render, staticRenderFns } from "./Datasources.vue?vue&type=template&id=492e9103&scoped=true&"
import script from "./Datasources.vue?vue&type=script&lang=ts&"
export * from "./Datasources.vue?vue&type=script&lang=ts&"
import style0 from "./Datasources.vue?vue&type=style&index=0&id=492e9103&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492e9103",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
